import FieldContainer from '../../../../shared/FormElements/FieldContainer/FieldContainer';
import RcSelect from '../../../../shared/FormElements/Selects/RcSelect';

const scanStatusOptions = [
  { id: 'no_new_scan', name: 'No new scan after last retainer shipment' },
  { id: 'new_scan', name: 'New scan taken since last retainer shipment' },
];

function WarrantyFormScanStatus() {
  return (
    <FieldContainer
      name="scanStatus"
      label="Updates on most recent 3D scan"
      required={true}
    >
      <RcSelect name="scanStatus" data={scanStatusOptions} clearable={false} />
    </FieldContainer>
  );
}

export default WarrantyFormScanStatus;
